{
  "vettingApp": "Vetting Management Application",

  "flipLang": "fr",
  
  "site":{
    "azurePortal": "Microsoft Azure Portal",
    "skipMainContent":"Skip to main content",
    "skipToFooter":"Skip to footer",
    "header":{
      "title": "Vetting Management",
      "languageSelection":"Language selection",
      "languageChange":"Français",
      "logout":"Sign out",
      "showProjectList": "Show project list",
      "hideProjectList": "Hide project list",
      "help": "Help",
      "vettingHandbook": "Vetting handbook",
      "opensNewTab": "Opens in new tab",
      "trainingDoc": "Training documentation",
      "getSupport": "Get support",
      "accountMenu": "Account menu",
      "betaAlert": "This is a beta version. This application functions best when used with a computer or laptop."
    },
    "footer":{
      "imageCaption":"Symbol of the Government of Canada",
      "dateModified": "Date modified:",
      "termsConditions": "Terms and conditions",
      "privacy":"Privacy"
    },
    "session":{
      "sessionTitle":"Extend session?",
      "sessionClosing": "Your session will be closing in {{time}}. Please select the \"Extend the session\" button to extend your session.",
      "extendSession": "Extend the session"
    },
    "requestTable":{
      "rowsPerPageLabel": "Rows per page: ",
      "vettingRequestDashboard":"Vetting requests dashboard",
      "rowsPerPageCount": "of"
    },
    "brandingAlt": "Statistics Canada"
  },
  "url":{
    "statcan": "https://www.statcan.gc.ca/eng/start",
    "privacy": "https://www.statcan.gc.ca/eng/reference/privacy",
    "termsConditions": "https://www.statcan.gc.ca/eng/reference/terms-conditions"
  },
  "dialog":{
    "close": "Close",
    "assigneeDetailsTitle2":"Assignees",
    "assigneeDetailsTitleLead":"Lead",
    "assigneeDetailsSupport": "Support",
    "assigneeDetailsTitle":"Assignee details",
    "assigneeDetailsClose":"Assignee details - close",
    "requesterDetailsTitle":"Requester details",
    "requesterDetailsClose":"Requester details - close",
    "assignAsSupportTitle":"Assign me as support",
    "assignAsSupportClose":"Assign me as support - close",
    "assignAsLeadTitle":"Assign me as lead",
    "assignAsLeadClose":"Assign me as lead - close",
    "assignAsLeadMainText":"To assign yourself to the request you must first enter a secure phone number",
    "assignAsLeadApply":"Assign",
    "assignAsLeadCancel":"Cancel",
    "noLeadNoLeadAssigned":"Continue with no lead?",
    "noLeadNoLeadClose":"Continue with no lead? - close",
    "noLeadMainText":"If you continue, the request will have no lead and the requester will be notified of the change.",
    "noLeadCancel":"Cancel",
    "noLeadContinue":"Continue",
    "newRequestDefaultTitle":"Untitled request",
    "warningConfidentialText":"Do not include any confidential information.",
    "labelCut":"Cut has been disabled for security purposes",
    "labelCopy":"Copy has been disabled for security purposes",
    "labelPaste":"Paste has been disabled for security purposes",
    "analystInfo":"Analyst information",
    "analystLabelClose":"Analyst information - close",
    "newRequestTitle":"New vetting request",
    "newRequestLabelClose":"New vetting request - close",
    "newRequestLabelName":"Enter the details below to start your request...",
    "newRequestLabelDescription": "Select the folder associated with this request. If the request folder cannot be found, please add it to the shared drive of your virtual machine. You will be required to place all associated files in this folder.",
    "newRequestLabelFolder": "Request folder path",
    "newRequestFolderError": "A folder must be provided",
    "newRequestLabelReqName":"Request name",
    "newRequestCancel":"Cancel",
    "newRequestClose":"Close",
    "newRequestCreate":"Create",
    "withdrawReason":"Select a withdraw reason.",
    "withdrawReasonLabel":"Withdraw reason",
    "withdrawTitle":"Withdraw Request",
    "withdrawRequest":"Withdraw",
    "withdrawCancel":"Cancel",
    "updateTitle":"Request changes",
    "updateCancel":"Cancel",
    "updateContentPara1":"What you need to do...",
    "updateContentPara2":"Click the \"Request changes\" button to notify the requester that changes will need to be made to the request.",
    "updateContentPara3":"Contact the requester on a secure communication channel indicating what changes need to be made.",
    "updateSubmitRequest":"Request changes",
    "updateClose":"Request changes - close",
    "approvedBillableHours":"Billable time",
    "approvedTitle":"Approve request",
    "approvedLabelHours":"Hours",
    "approvedLabelMinutes":"Minutes",
    "approvedCancel":"Cancel",
    "approvedSubmit":"Submit",
    "approvedLabelClose":"Approve request - close",
    "approveBillabeMinutesError":"Enter billable minutes",
    "approveBillabeHoursError":"Enter billabe hours",
    "deniedTitle":"Don't approve request",
    "deniedBillableHours": "Billable time",
    "deniedLabelHours": "Hours",
    "deniedLabelMinutes": "Minutes",
    "deniedReason":"Reason",
    "deniedSelectOption":"Select an option",
    "deniedComments":"Comments",
    "deniedCancel":"Cancel",
    "deniedSubmit":"Submit",
    "deniedLabelClose":"Don't approve request - close",
    "deniedBillabeHoursError":"Enter billabe hours",
    "deniedBillabeMinutesError":"Enter billable minutes",
    "deniedReasonError":"Select a reason",
    "deniedCommentError":"Enter a comment",
    "deleteText":"If you delete this item, it cannot be undone.",
    "deleteSubmit":"Delete",
    "deleteCancel":"Cancel",
    "deleteLabelClose":"Delete permanently - close",
    "deleteTitle":"Delete permanently?",
    "assignPhoneNumber":"Provide a phone number",
    "assignLabelPhoneNumber":"Phone number",
    "assignPhoneNumberError":"Enter a phone number",
    "assignCancel":"Cancel",
    "assignSubmit":"Continue",
    "assignLabelClose":"Make me lead - close",
    "supportFormTitle":"Get support",
    "supportFormTitleClose":"Get support - close",
    "supportFormContentPara1":"Do you need help with something?",
    "supportFormContentPara2":"Select the steps you need help with. ",
    "supportFormContentPara3":"Select all that apply",
    "supportFormContentPara4":"Click the \"Get support\" button and one of our Analysts will contact you to resolve the issue. We aim to make contact within 1 to 2 business days.",
    "supportFormCancel" :"Cancel",
    "supportFormSubmit":"Get support",
    "supportContentPara1":"Do you need help with something?",
    "supportContentPara2":"Click the \"Get support\" button and one of our Analysts will contact you to resolve the issue. We aim to make contact within 1 to 2 business days.",
    "supportCancel" :"Cancel",
    "supportClose": "Close",
    "supportSubmit":"Get support",
    "supportTitle":"Get support",
    "unassignTitle":"Unassign from me",
    "unassignText":" If you choose to proceed, the request will no longer have a lead analyst.",
    "unassignCancel":"Cancel",
    "unassignSubmit":"Unassign",
    "unassignLabelClose":"Unassign from me - close",
    "manageTeamNoLead":"No lead assigned",
    "manageTeamTitle":"Manage team",
    "manageTeamLead":"Lead",
    "manageTeamSearchSupport":"Search support analysts",
    "manageTeamAddSupport":"Add support analyst",
    "manageTeamSupportAnalysts":"Support Analysts",
    "manageTeamCancel":"Cancel",
    "manageTeamSubmit":"Apply",
    "manageTeamLabelClose":"Manage team - close",
    "saveBeforeLeaveTitle": "Save before leaving?",
    "saveBeforeLeaveClose": "Save before leaving - close",
    "saveBeforeLeaveMessage": "If you don't save, your changes will be lost.",
    "saveBeforeLeaveDontSave": "Don't save",
    "saveBeforeLeaveCancel": "Cancel",
    "saveBeforeLeaveSave": "Save",
    "outputMethodHelpTitle": "Output method help",
    "outputMethodHelpClose": "Output method help - close",
    "outputMethodHelpCloseButton": "Close",
    "addFileTitleView": "View support file",
    "addFileTitleEdit": "Edit support file",
    "addFileTitleAdd": "Add support file",
    "addFileTitleClose": "Add file - close",
    "addFileContent_syntaxFile": "Select syntax or log file",
    "addFileContent_variableListFile": "Select variable list and/or variable description",
    "addFileContent_other": "Select additional support file",
    "addFileContent_correctDocFile": "Select correct supporting documentation (see vetting rules)",
    "addFileContent_frequencyTablefile": "Select unweighted frequency table for respondent counts",
    "addFileContent_sampleSizeFile": "Select unweighted sample size",
    "addFileContent_crossTabFile": "Select unweighted cross-tabulation table",
    "addFileContent_subTotalsFile": "Select unweighted sub-totals for the categories of the dichotomous variable correlated with a continuous variable",
    "addFileContent_unroundedFile": "Select unrounded version of this output",
    "addFileContent_dominanceTestingFile": "Select test results",
    "addFileContent_continuousVariablesSensitivityFile" : "Select sensitivity test results",
    "addFileContent_residualTablesFile": "Select residual table (see vetting orientation)",
    "addFileContent_previousRelease_residualTablesFile": "Select residual table (see vetting orientation)",
    "addFileContent_bothSetsFile": "Select both sets of syntax with changes highlighted",
    "addFileContent_previousRelease_bothSetsFile": "Select both sets of syntax with changes highlighted",
    "addFileFilePath": "File path",
    "addFileNotes": "Notes",
    "addFileCancel": "Cancel",
    "addFileClose": "Close",
    "addFileUpdate": "Update",
    "addFileAdd": "Add",
    "addFileError": "This field is required"
  },
  "notifications":{
    "vettingRequestCreated":"Request created",
    "vettingRequestWithdrawn":"Request withdrawn",
    "vettingRequestDeleted":"Request deleted",
    "vettingRequestSubmitted":"Request submitted",
    "vettingRequestReopened":"Request has been put back in the active requests as a draft",
    "assignedAnalystsUpdated":"Assignee changes applied",
    "vettingRequestApproved":"Request approved",
    "vettingRequestAssignToMe":"Assigned as lead",
    "vettingRequestAssignAsSupport":"Assigned as support",
    "vettingRequestUnassigned":"Unassigned",
    "vettingRequestDenied":"Request not approved",
    "vettingRequestUpdateRequested":"Change request sent",
    "vettingRequestStartReview":"Request review started",
    "vettingRequestHelpRequested":"Support request sent",
    "vettingRequestDuplicated":"Request duplicated"
  },
  "contextMenu":{
    "assigneeDetails":"Assignee details",
    "requesterDetails":"Requester details",
    "edit":"Edit",
    "view":"View request",
    "delete": "Delete",
    "summary":"Summary",
    "withdraw":"Withdraw",
    "submit":"Submit",
    "resubmit":"Submit",
    "reopen":"Reactivate",
    "dialogBox":{
      "message": "Are you sure you want to delete that request?"
    },
    "startReview":"Start review",
    "unassign":"Unassign user",
    "unassignMe":"Unassign myself",
    "makeSupport":"Assign user as support",
    "makeMeSupport": "Assign me as support",
    "makeLead":"Assign user as lead",
    "manageTeam":"Manage assignees",
    "assignToMe":"Assign me as lead",
    "requestUpdate":"Request changes",
    "denyRequest":"Don't approve",
    "approve":"Approve",
    "duplicate": "Duplicate"
  },
  "assigneeDrawer":{
    "noLeadAssigned":"No lead assigned",
    "you":" (You)",
    "noSupportAssigned":"No support assigned",
    "manageAssignees":"Manage assignees",
    "closePanel": "Manage assignee panel - close panel",
    "assignees":"Assignees",
    "assignMeAs":"Assign me as",
    "assignMeAsLead":"Assign me as lead",
    "assignMeAsSupport":"Assign me as support",
    "lead":"Lead",
    "support":"Support",
    "cancel":"Cancel",
    "apply":"Apply"
  },
  "summaryDrawer":{
    "summary":"Vetting request summary",
    "projectName":"Project name",
    "viewRequest": "View vetting request",
    "filesRequested":"Files requested",
    "billableHours":"Billable time",
    "labelBillableMinutes":"minute",
    "labelBillableMinutes_plural":"minutes",
    "labelBillableHours":"hour",
    "labelBillableHours_plural":"hours",
    "principalAnalyst":"Lead analyst",
    "latestStatusLabel":{
      "approved":"Approved",
      "updateRequest":"Changes requested",
      "denied":"Not approved",
      "submitted":"Submitted",
      "draft":"Created",
      "disclosureAnalysis":"Review started",
      "withdraw":"Withdrawn"
    },
    "labelRequestInfo":"Request information panel - close panel"
  },
  "commonDashboard":{
    "updatedOn":{
      "justNow":"Just now",
      "minAgo":"{{count}} min ago",
      "minAgo_plural":"{{count}} mins ago",
      "hourAgo":"{{count}} hour ago",
      "hourAgo_plural":"{{count}} hours ago"
    }
  },
  "adminDashboard":{
    "title":"Administrative dashboard"
  },
  "researcherDashboard":{
    "title":"Dashboard • Vetting Management • Data Analytics as a Service • Statistics Canada",
    "newVettingRequest":"New vetting request",
    "tabs":{
      "active":"Active",
      "withdrawn":"Withdrawn",
      "approved":"Approved",
      "denied": "Not approved"
    },
    "tableHeader":{
      "id":"ID",
      "request":"Request",
      "researcher":"Requester",
      "status":"Status",
      "analyst":"Assignee",
      "createdOn":"Created",
      "updatedOn": "Updated"
    },
    "tabsLabel": "Vetting request tabs",
    "analystCell":{
      "labelUnassigned": "Unassigned"
    }
  },
  "analystDashboard":{
    "title":"Dashboard • Vetting Management • Data Analytics as a Service • Statistics Canada",
    "tabs":{
      "assignedToMe":"Assigned to me",
      "unassigned":"Unassigned",
      "active":"Active",
      "approved":"Approved",
      "denied": "Not approved"
    },
    "tableHeader":{
      "id":"ID",
      "request":"Request",
      "researcher":"Requester",
      "project": "Project",
      "status":"Status",
      "lead":"Assignee",
      "createdOn":"Created",
      "updatedOn": "Updated"
    },
    "tabsLabel": "Vetting request tabs",
    "manageTeamLink":"Manage team",
    "labelNoLead":"No lead",
    "labelSupport":"Support",
    "analystCell":{
      "labelUnassigned": "Unassigned"
    }
  },
  "drawer":{
    "projectsCaption":"Projects",
    "itemAll":"All"
  },
  "administration":{
    "drawer":{
      "menuCaption":"Menu"
    }
  },
  "copyPaste":{
    "understood": "Understood",
    "functionalityDisabled": "Cut, copy and paste functionality has been disabled on text fields for security purposes."
  },
  "inputs":{
    "required": "required",
    "virtualizedAutocomplete":{
      "clearText": "clear",
      "closeText": "close",
      "openText": "open"
    }
  },
  "requestForm": {
    "requestReviewFolderName": "Analyst review folder name",
    "toolTipMoreInformation": "More information",
    "title": "Request {{request}} • Vetting Management • Data Analytics as a Service • Statistics Canada",
    "project": "Project",
    "request": "Request",
    "status": "Status",
    "requester": "Requester",
    "assignee": "Assignee",
    "unassigned": "Unassigned",
    "noLead": "No lead",
    "support": "{{count}} support",
    "back": "Back",
    "next": "Next",
    "submitRequest": "Submit request",
    "cancel": "Cancel",
    "close": "Close",
    "errors": "{{count}} error",
    "errors_plural": "{{count}} errors",
    "yes": "Yes",
    "no": "No",
    "errorWithRequest": "There seems to be an error with this request and it has to be deleted. The folders associated with this request have been deleted from the storage.",
    "successSave": "Request saved",
    "areYouSure": "Are you sure?",
    "outputAdded": "Output file added",
    "outputEdited": "Output file updated",
    "outputDeleted": "Output file deleted",
    "otherSupportingAdded": "Support file added",
    "otherSupportingEdited": "Support file edited",
    "otherSupportingDeleted": "Support file deleted",
    "toolbar":{
      "dashboard": "Dashboard",
      "save": "Save",
      "submit": "Submit",
      "delete": "Delete",
      "requestUpdate": "Request changes",
      "resolve": "Resolve",
      "approve": "Approve",
      "deny": "Don't approve",
      "assignMeLead": "Assign me as lead",
      "assignMeSupport": "Assign me as support",
      "unassignMe": "Unassign myself",
      "withdraw": "Withdraw",
      "reactivate": "Reactivate",
      "startReview": "Start review",
      "summary": "Summary",
      "requesterDetails": "Requester details",
      "assigneeDetails": "Assignee details",
      "manageAssignees": "Manage assignees"
    },
    "researcherInformation":{
      "title":"Request details",
      "description": "Vetting of statistical output is required by Statistics Canada to ensure data protection. Statistics Canada Analysts will review all external users' vetting requests. These requests are subject to a risk-based assessment of potential disclosure based on established rules and procedures.",
      "requestDetails": "Request details", 
      "details": "Details", 
      "requestId": "Request ID", 
      "requestName": "Request name",
      "project": "Project",
      "requester": "Requester",
      "firstName": "First name",
      "lastName": "Last name",
      "email": "Email",
      "createdOn": "Created",
      "updatedOn": "Updated",
      "username": "Username",
      "role": "Role"
    },
    "filesList":{
      "title": "Output files for vetting",
      "outputFiles": "Output files",
      "outputFilesTip": "Add the files containing your statistical output that you would like to have vetted and released from the secure environment.",
      "explanation": "Please prepare and add your files for vetting. You will not have access to your files from within this request and are simply adding the file path to help Analysts locate the file on your virtual machine. If your request is approved you will be granted access to your files outside of your secure environment.",
      "screeningQuestions": "Screening questions",
      "pleaseConsider": "Please consider the following guidelines:",
      "checkAgainstGuidelines": "Check your output against the vetting guidelines.",
      "deleteNotNeeded": "Delete values you do not need released at this time.",
      "requestStored": "This request will be stored as part of the request record.",
      "consistentOutput": "Is the requested output consistent with the approved proposal for this project?",
      "vettingRules": "Have you checked the vetting rules to determine if there are specific requirements for your output (e.g., geographical, institutional, household, population, firm, etc.)?",
      "finalOutput": "Is the requested output your final output?",
      "finalOutputTip": "If no, future vetting release requests under this contract may be restricted due to residual disclosure. You are strongly encouraged to consult with your Analyst.",
      "requestFolder": "Request folder path",
      "areYouSureOutput": "Are you sure you want to continue with this action? This will reset the files associated with this request.",
      "edit": "Edit",
      "view": "View",
      "review": "Review",
      "outputError": "{{count}} error",
      "outputError_plural": "{{count}} errors",
      "maxOutputFiles": "Max output files attained",
      "maxSupportFiles": "Max support files attained",
      "mandatorySupportingFiles": "Mandatory supporting files",
      "mandatorySupportingFilesTip": "These files are to support the vetting request and will not be released.",
      "variableListFileTip": "Include information for derived or recoded variables (e.g. syntax, codebook, description).",
      "additionalSupportingFiles": "Additional supporting files",
      "finalOutputGuidelines" : "Future vetting release requests under this contract may be restricted due to residual disclosure. You are strongly encouraged to consult with your Analyst.",
      "finalOutputGuidelinesPara2" : "For economic data projects, intermediary output is expected to be very limited. Due to residual disclosure, the output requested must be as close to final as possible. Multiple iterations of the output will not be released, barring an academic/journal review has been requested for the project. Consult with your Analyst for strategies to release intermediary output."
    },
    "modifyFile":{
      "addOutputFile": "Add output file",
      "editOutputFile": "Edit output file",
      "viewOutputFile": "View output file",
      "reviewOutputFile": "Review output file",
      "selectOutput": "Select output file for vetting",
      "outputFile": "File path",
      "sheetName": "Sheet name",
      "sheetNameHelper": "For spreadsheets only.",
      "outputDetails": "Output details",
      "datasetName": "Surveys/Datasets and cycles",
      "datasetNameHelper": "Separate by semicolon (e.g., LFS 2012; LFS 2011; CCHS 2009)",
      "outputMethod": "Output method",
      "outputMethodDescription": "Output method description",
      "needHelp": "Need help?",
      "outputMethodLearn": "Learn about output methods",
      "checkVettingGuidelines": "Check the vetting guidelines and requirements for these kinds of variables. Consult with your Analyst if needed.",
      "methods": {
        "descriptiveMethod": "Descriptive", 
        "descriptiveMethodExamples": ["ANOVA",
          "Correlation matrix",
          "Cross-tabular analysis",
          "Distributions",
          "Frequencies",
          "Kurtosis",
          "Means",
          "Medians",
          "Modes",
          "Percentages",
          "Quartiles",
          "Ranges",
          "Ratios",
          "Regression models with only one independent variable",
          "Skewness",
          "Standard deviations",
          "Totals",
          "Variances"],
        "scalingMethod": "Scaling",
        "scalingMethodExamples": ["Factor Analysis"],
        "graphsMethod": "Graphs",
        "graphsMethodExamples": ["Histograms"],
        "regressionMethod": "Multivariable regression analysis",
        "regressionMethodExamples": ["Logistic",
          "OLS",
          "Poisson",
          "Probit",
          "Tobit"],
        "modelingMethod": "Complex modeling",
        "modelingMethodExamples": ["Event History Analysis",
          "Fixed Effects Models",
          "Growth Analysis",
          "Hierarchical Linear Modeling",
          "Random Effects Models",
          "Simultaneous-Equations Models",
          "Structural equation modeling",
          "Survival Analysis"],
        "otherMethod": "Other"
      },
      "examplesInclude": "Examples include: {{content}}",
      "weightedVariable": "Weighted variable",
      "includeWeightVariable": "Does this output include a weight variable?",
      "weightVariableName": "Weighted variable name",
      "weightVariableType": "Was the weighted variable scaled/normalized?",
      "sampleUsed": "Sample, sub-sample, inclusion/exclusion",
      "sampleUsedHelper": "(e.g., Employed females, aged 21-45, in Ontario)",
      "sampleUsedTooltip": "Describe each of the different samples, sub-samples, or inclusions/exclusions used to produce your output.",
      "geographyLevel": "Geography level",
      "geographyLevelHelper": "(e.g., national, provincial, municipal)",
      "linkedDataTitle": "Linked Data",
      "linkedData": "Is linked data used?",
      "linkedDataDescription": "Linkage method",
      "linkedDataDescriptionHelper": "(e.g. person-based, record-based, matching geographies)",
      "descriptiveStatsTitle": "Descriptive statistics",
      "descriptiveStats": "Does the request include descriptive statistics?",
      "outputLabelled": "Is the output clearly labelled (tables have a title and every variable and category is labelled)?",
      "minCellSize": "Are minimum cell sizes met as per the rules for the data?",
      "correctDocFileTip": "(e.g. counts are unweighted, weighted, weighted and rounded)",
      "equivalentDescriptiveStats": "Does this request include model output or graphs that are equivalent to a descriptive statistic?",
      "equivalentDescriptiveStatsTip": "Examples: a model with a single independant variable, a model with all possible interactions, histograms",
      "matrixTitle": "Correlation/Covariance matrix",
      "includeMatrix": "Does this output include a correlation or covariance matrix?",
      "continuousVariables": "Does the matrix include continuous variables?",
      "dichotomousVariables": "Does the matrix include dichotomous variables?",
      "correlatedVariables": "Does the matrix include a dichotomous variable correlated with a continuous variable?",
      "rounding": "Rounding",
      "roundingOutput": "Is rounding of output required for this vetting request?",
      "roundingOutputTip": "If yes, ensure that any forced rounding to zero is shown.",
      "roundingOutputDescription": "Rounding approach description",
      "dominanceTesting" : "Dominance Testing",
      "dominanceTestingOutput" : "Does the output contain variables that require dominance testing (see vetting guidelines)?",
      "economicData":"Economic Data",
      "economicDataOutput":"Is your output generated from economic data?",
      "uniqueDataUnits":"Does the output (i.e., descriptive statistics and number of observations in a model) meet the requirements for the minimum number of unique data units?",
      "outputContinuousVariables":"Does your output contain continuous variables?",
      "continuousVariablesSensitivity":"Do all continuous variables meet sensitivity requirements as outlined in the vetting rules?",
      "reviseOutput":"Please revise the output or discuss with your Analyst.",
      "additionalSupportingFiles": "Additional supporting files",
      "add": "Add",
      "update": "Update",
      "keepAnswersTitle": "File Change",
      "keepAnswers": "Would you like to keep your answers for this file?",

      "addSupportingFilesTitle_syntaxFile": "Add syntax or log file",
      "addSupportingFilesTitle_variableListFile": "Add variable list and/or variable description",
      "addSupportingFilesTitle_other": "Add additional support file",
      "addSupportingFilesTitle_correctDocFile": "Add correct supporting documentation (see vetting rules)",
      "addSupportingFilesTitle_frequencyTablefile": "Add unweighted frequency table for respondent counts",
      "addSupportingFilesTitle_sampleSizeFile": "Add unweighted sample size",
      "addSupportingFilesTitle_crossTabFile": "Add unweighted cross-tabulation table",
      "addSupportingFilesTitle_subTotalsFile": "Add unweighted sub-totals for the categories of the dichotomous variable correlated with a continuous variable",
      "addSupportingFilesTitle_subTotalsFile_para2": "For output generated from economic data, also provide the test for the continuous variable’s sensitivity at each category",
      "addSupportingFilesTitle_dominanceTestingFile" : "Add test results",
      "addSupportingFilesTitle_dominanceTestingFile_note" : "Note: to avoid adding files individually, they can be zipped into a single file and added together.",
      "addSupportingFilesTitle_continuousVariablesSensitivityFile":"Add sensitivity test results",
      "addSupportingFilesTitle_continuousVariablesSensitivityFile_note":"Note: to avoid adding files individually, they can be zipped into a single file and added together.",
      "addSupportingFilesTitle_unroundedFile": "Add unrounded version of this output",
      "addSupportingFilesTitle_residualTablesFile": "Add residual table (see vetting orientation)",
      "addSupportingFilesTitle_previousRelease_residualTablesFile": "Add residual table (see vetting orientation)",
      "addSupportingFilesTitle_bothSetsFile": "Add both sets of syntax with changes highlighted",
      "addSupportingFilesTitle_previousRelease_bothSetsFile": "Add both sets of syntax with changes highlighted",
      "addOutputFileTitle": "Add output file for vetting",
      "addSupportingFilesOneFile": "At least one file must be added",
      "addSupportingFilesButton": "Add support file",
      "addOutputFileButton": "Add output file",
      "addSupportingFilesCardTitle": "File {{index}} · $t(requestForm.supportingFiles.{{fileType}})",
      "addOutputFileCardTitle": "File {{index}} · Output file for vetting",
      "addSupportingFilesEdit": "Edit",
      "addSupportingFilesDelete": "Delete",
      "addSupportingFilesFilePath": "File path",
      "addSupportingFilesNotes": "Notes",
      "addSupportingFilesNoOutput": "No output files added",
      "addSupportingFilesNoSupport": "No support files added"
    },
    "residualDisclosure":{
      "title":"Residual disclosure",
      "description": "A re-release of the same output after slight modifications greatly increases the risk of residual disclosure. Statistics Canada strongly recommends that researchers submit as few versions of the output as possible.",
      "subsetVariables": "For this request, have you subsetted any variables, where one or more variables is a subset of another?",
      "subsetVariablesTip": "(e.g. had depression in the past 5 years and had depression in the previous year; had a chronic condition and had a respiratory chronic condition)",
      "subsetVariables_changedSubSample": "Compared to the other subset, have you changed the sub-sample of population of interest?",
      "subsetVariables_droppedOutliers": "Compared to the other subset, have you dropped individual cases or outliers?",
      "subsetVariables_imputedData": "Compared to the other subset, have you imputed the missing data?",
      "subsetVariables_modifiedVariables": "Compared to the other subset, have you recoded or modified any variables even slightly?",
      "previousRelease": "Has a version of this output, in part of in whole, been previously released for this project?",
      "previousRelease_changedSubSample": "Compared to the other output, have you changed the sub-sample of population of interest?",
      "previousRelease_droppedOutliers": "Compared to the other output, have you dropped individual cases or outliers?",
      "previousRelease_imputedData": "Compared to the other output, have you imputed the missing values?",
      "previousRelease_modifiedVariables": "Compared to the other output, have you recoded or modified any variables even slightly?",
      "listSubsetted": "List subsetted variables",
      "explainChanges": "Explanation of changes",
      "dateRelation": "Related request date",
      "dateRelationHelper": "Indicate the date(s) of the previous vetting requests related to this request."
    },
    "additionalInformation":{
      "title":"Additional information",
      "text": "Use this section to add any information that you think might be helpful for the Analyst(s) while reviewing your vetting request."
    },
    "supportingFiles":{
      "correctDocFile": "Correct supporting documentation (see vetting rules)",
      "correctDocFile_noExplain": "Correct supporting documentation",
      "frequencyTablefile": "Unweighted frequency table for respondent counts",
      "sampleSizeFile": "Unweighted sample size",
      "crossTabFile": "Unweighted cross-tabulation table",
      "subTotalsFile": "Unweighted sub-totals for the categories of the dichotomous variable correlated with a continuous variable",
      "unroundedFile": "Unrounded version of this output",
      "syntaxFile": "Syntax or log file",
      "variableListFile": "Variable list and/or variable description",
      "residualTablesFile": "Residual table (see vetting orientation)",
      "residualTablesFile_noExplain": "Residual table",
      "bothSetsFile": "Both sets of syntax with changes highlighted",
      "other": "Other",
      "additionalDetails": "Additional support file",
      "dominanceTestingFile": "Test results",
      "continuousVariablesSensitivityFile": "Sensitivity test results"

    }
  },
  "inactiveWindowTabTitle": "Browser tab inactive",
  "applicationErrorMessage":{
    "request":{
      "requiredErrorMessage": "This field is required.",
      "formErrors": "Request not submitted ({{count}} error)",
      "formErrors_plural": "Request not submitted ({{count}} errors)",
      "intenseFormErrors": "Request not submitted (99+ errors)",
      "invalidOutputs": "The output files in the request are invalid.",
      "invalidFiles": "Some files in the request are invalid.",
      "requestErrorDeleting":"Error deleting request.",
      "unauthorizedUserRole": "You are not authorized to perform this action.",
      "requestNotFound": "The request could not be found.",
      "unauthorizedEditRequest": "You are not allowed to edit this request",
      "submitError": "An error occurred while submitting.",
      "copyError": "An error occurred while copying the files.",
      "invalidProject": "Invalid project. Refreshed data.",
      "invalidRequestStatus": "Invalid status",
      "unexpectedError": "Unexpected error occured.",
      "deletedFile": "This file was deleted",
      "accessKeyError": "An error occurred while getting the Azure access key",
      "helpAlreadySent":"A help request has already been sent for this request",
      "requestCantTransferFile":"Files couldn't be transfered. Please try again.",
      "notLoggedIn":"You don't have an active session. Please refresh your browser.",
      "invalidRate":"You can't create a new request at this time. Please try again.",
      "invalidRequestFolder":"The folder path is not valid."
    },
    "generic":{
      "dataError": "An error occurred while getting data. Please try again.",
      "projectError": "An error occurred while setting the project. Please try again.",
      "unexpectedError": "Unexpected error occured.",
      "missingRequiredField":"Required field(s) missing.",
      "notLoggedIn":"You don't have an active session. Please refresh your browser.",
      "tabInactive": "This browser tab is no longer active. Please close it.",
      "userNotExistDatabase": "Your account does not exist in our database. Please switch to your VDL authorized cloud account using the",
      "userNoProjects": "You don't have active projects.",
      "unexpectedBrowserError": "An error occurred. Please refresh your browser."
    }
  }
}